import React from 'react';
import { ITextQuestionView } from 'store/survey/surveyTypes';

interface IComponentProps {
  maxLength: ITextQuestionView['maxLength'];
  inputType: ITextQuestionView['inputType'];
}

const TextFieldsViewer: React.FC<IComponentProps> = () => {
  // TODO: show maxLength and inputType here

  return null;
};

export default TextFieldsViewer;
